import { Injectable } from '@angular/core';

import { AnalyticsBase } from '../lib/analytics-base';

@Injectable()
export class EventsAnalytics extends AnalyticsBase {
  public readonly namespace = 'Events';
  public readonly requireViewContext = true;

  public trackSchedule() {
    this.track('Schedule', {});
  }

  public trackEventScheduled(
    eventType: string,
    isMoreInterviewers: boolean,
    isEvaluationRequested: boolean,
  ) {
    this.track('EventScheduled', { eventType, isMoreInterviewers, isEvaluationRequested });
  }
}
